import {
  IDatasetProcessingError,
  IDataset,
  TDatasetColumnType,
} from 'FeatureModules/DataImport/types/dataset.types';

export interface IDatasetMappedColumn {
  targetColumnName: TDatasetColumnType;
  sourceColumnName: string;
}

export interface ICreateDatasetInput {
  title?: string;
  originCountry: string;
  rawMaterialId: string;
  ownedById: string;
  documentIds: string[];
  dataType?: 'GEODATA' | 'WORKERS';
  geoDataProcessIds?: string[];
}
export type IUpdateDatasetInput = Partial<ICreateDatasetInput>;

export interface IProcessDatasetInput {
  datasetId: string;
  overwriteExisting?: boolean;
  clusterSites?: boolean;
  siteClusterId?: string;
  mappedColumns?: IDatasetMappedColumn[];
  decimalSeperator?: string;
  csvSeperator?: string | null;
}

export type IPreProcessDatasetInput = Omit<
  IProcessDatasetInput,
  'clusterSites' | 'siteClusterId' | 'overwriteExisting'
> & {
  overwriteMappedColumns?: boolean;
  autoCloseGeojsonGeometries?: boolean;
};

export interface IProcessDatasetPayload {
  dataset: IDataset;
  datasetProcessingError?: IDatasetProcessingError;
}

export type IPreProcessDatasetPayload = IProcessDatasetPayload;

export enum EGeoDataExportType {
  VALIDATED = 'VALIDATED',
  VERIFIED = 'VERIFIED',
}

export type TGeoDataExportType = `${EGeoDataExportType}`;

export enum EGeoDataExportFormat {
  CSV = 'CSV',
  EXCEL = 'EXCEL',
  GEOJSON = 'GEOJSON',
}

export type TGeoDataExportFormat = `${EGeoDataExportFormat}`;

export type ICreateGeoEntitiesExportInput = { exportFormat: TGeoDataExportFormat } & (
  | { parcelInput: { ids: string[] }; geoDataInput?: never }
  | {
      parcelInput?: never;
      geoDataInput: {
        id: string;
        type: TGeoDataExportType;
      };
    }
);
